import { createAuthClient } from "better-auth/react";

/**
 * A second Better Auth client, pointed at the second Better Auth instance
 * (`apps/api/src/portal-auth.ts`) — never the staff one in `auth-client.ts`.
 *
 * Same-origin, so no `baseURL` is needed here either. The two sessions don't
 * collide in the same browser because the *server* instance uses a distinct
 * `basePath` and `advanced.cookiePrefix`, giving this client's cookie a
 * different name than the staff one.
 */
export const portalAuthClient = createAuthClient({ basePath: "/api/portal/auth" });

export const {
  signIn: portalSignIn,
  signUp: portalSignUp,
  signOut: portalSignOut,
  useSession: usePortalSession,
} = portalAuthClient;
